export default __webpack_public_path__ + "static/media/DrugRegistry.bf733c4a.svg";